import Button from '../Button/Button';
import woodenchair from '../../assets/images/wooden-chair 1.svg';
import { useNavigate } from 'react-router';
import { useEffect, useState } from 'react';

const SchoolSubjectCard = ({
  id,
  description,
  duration,
  schoolHeader,
  selectSchool,
  topic,
  lessonCount,
  lessonStyle,
  price,
  currency,
  studentCount,
  subjectClass,
  maxStudents,
  school,
  index,
}) => {
  const navigate = useNavigate();

  const [bg, setBg] = useState('');

  useEffect(() => {
    if (index % 2) {
      setBg('#FFCC1D');
    } else if (index % 3) {
      setBg('#FFAEC0');
    } else {
      setBg('#9FECDB');
    }
  }, []);

  return (
    <div
      className='school-card'
      style={{
        boxShadow: `10px 10px 0px 0px ${bg}`,
        margin: '34px 0',
      }}
    >
      <img src={schoolHeader} alt='' className='school-card__school-img' />
      <div className='school-card__body'>
        <div className='school-card__body__title'>
          {price ? (
            <h3
              onClick={() => navigate(`/courses/${topic}-${id}?school=${id}`)}
            >
              {topic}
            </h3>
          ) : (
            <h3>{topic}</h3>
          )}
          {price ? (
            <h2>
              {Number(price) === 0 ? (
                'Free'
              ) : (
                <>
                  {currency}
                  {Number(price)?.toLocaleString('en')}
                </>
              )}
            </h2>
          ) : (
            <p>
              {' '}
              {description?.length > 100
                ? `${description?.substring(0, 50)}...`
                : description}
            </p>
          )}
        </div>

        <div className='school-card__body__flex' style={{ marginBottom: '0' }}>
          <div className='school-card__body__flex__item'>
            <svg
              width='12'
              height='12'
              viewBox='0 0 12 12'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M6.00033 1.99984C6.73366 1.99984 7.33366 2.59984 7.33366 3.33317C7.33366 4.0665 6.73366 4.6665 6.00033 4.6665C5.26699 4.6665 4.66699 4.0665 4.66699 3.33317C4.66699 2.59984 5.26699 1.99984 6.00033 1.99984ZM6.00033 8.6665C7.80032 8.6665 9.86699 9.5265 10.0003 9.99984H2.00033C2.15366 9.51984 4.20699 8.6665 6.00033 8.6665ZM6.00033 0.666504C4.52699 0.666504 3.33366 1.85984 3.33366 3.33317C3.33366 4.8065 4.52699 5.99984 6.00033 5.99984C7.47366 5.99984 8.66699 4.8065 8.66699 3.33317C8.66699 1.85984 7.47366 0.666504 6.00033 0.666504ZM6.00033 7.33317C4.22033 7.33317 0.666992 8.2265 0.666992 9.99984V11.3332H11.3337V9.99984C11.3337 8.2265 7.78032 7.33317 6.00033 7.33317Z'
                fill='#5A5955'
              />
            </svg>

            <p style={{ fontSize: '14px' }}>{lessonStyle}</p>
          </div>

          <div className='school-card__body__flex__item'>
            <svg
              width='16'
              height='16'
              viewBox='0 0 16 16'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M12.6667 3.33333V12.6667H3.33333V3.33333H12.6667ZM12.6667 2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V3.33333C14 2.6 13.4 2 12.6667 2Z'
                fill='#5A5955'
              />
              <path
                d='M9.33366 11.3332H4.66699V9.99984H9.33366V11.3332ZM11.3337 8.6665H4.66699V7.33317H11.3337V8.6665ZM11.3337 5.99984H4.66699V4.6665H11.3337V5.99984Z'
                fill='#5A5955'
              />
            </svg>
            <p style={{ fontSize: '14px' }}>{lessonCount} Lessons</p>
          </div>
        </div>
        <div
          className='school-card__body__flex'
          style={{ marginBottom: subjectClass ? '0px' : '32px' }}
        >
          <div className='school-card__body__flex__item'>
            <svg
              width='14'
              height='14'
              viewBox='0 0 14 14'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M6.99301 0.333496C3.31301 0.333496 0.333008 3.32016 0.333008 7.00016C0.333008 10.6802 3.31301 13.6668 6.99301 13.6668C10.6797 13.6668 13.6663 10.6802 13.6663 7.00016C13.6663 3.32016 10.6797 0.333496 6.99301 0.333496ZM6.99967 12.3335C4.05301 12.3335 1.66634 9.94683 1.66634 7.00016C1.66634 4.0535 4.05301 1.66683 6.99967 1.66683C9.94634 1.66683 12.333 4.0535 12.333 7.00016C12.333 9.94683 9.94634 12.3335 6.99967 12.3335ZM7.33301 3.66683H6.33301V7.66683L9.83301 9.76683L10.333 8.94683L7.33301 7.16683V3.66683Z'
                fill='#5A5955'
              />
            </svg>

            <p style={{ fontSize: '14px' }}>{duration || 0}</p>
          </div>

          <div className='school-card__body__flex__item'>
            <svg
              width='16'
              height='16'
              viewBox='0 0 16 16'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <g clipPath='url(#clip0_4425_23761)'>
                <path
                  d='M12.6667 3.33333V12.6667H3.33333V3.33333H12.6667ZM12.6667 2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V3.33333C14 2.6 13.4 2 12.6667 2ZM8 8C6.9 8 6 7.1 6 6C6 4.9 6.9 4 8 4C9.1 4 10 4.9 10 6C10 7.1 9.1 8 8 8ZM8 5.33333C7.63333 5.33333 7.33333 5.63333 7.33333 6C7.33333 6.36667 7.63333 6.66667 8 6.66667C8.36667 6.66667 8.66667 6.36667 8.66667 6C8.66667 5.63333 8.36667 5.33333 8 5.33333ZM12 12H4V10.98C4 9.31333 6.64667 8.59333 8 8.59333C9.35333 8.59333 12 9.31333 12 10.98V12ZM5.54 10.6667H10.46C10 10.2933 8.87333 9.92 8 9.92C7.12667 9.92 5.99333 10.2933 5.54 10.6667Z'
                  fill='#5A5955'
                />
              </g>
              <defs>
                <clipPath id='clip0_4425_23761'>
                  <rect width='16' height='16' fill='white' />
                </clipPath>
              </defs>
            </svg>
            <p style={{ fontSize: '14px' }}>
              {studentCount}/{maxStudents} Enrolled
            </p>
          </div>
        </div>

        {subjectClass && (
          <div
            className='school-card__body__flex'
            style={{ marginBottom: '32px' }}
          >
            <div className='school-card__body__flex__item'>
              <img src={woodenchair} alt='' />
              <p style={{ fontSize: '14px' }}>{subjectClass}</p>
            </div>
          </div>
        )}
        {price ? (
          <Button
            text={'View Lesson'}
            className='orange-border'
            width='100%'
            onClick={() =>
              navigate(`/courses/${topic}-${id}?school=${school?.id}`)
            }
          />
        ) : (
          <Button
            text={price ? 'View Lesson' : 'Start Learning'}
            className='orange-border'
            width='100%'
            onClick={selectSchool}
          />
        )}
      </div>
    </div>
  );
};

export default SchoolSubjectCard;
